import { render, staticRenderFns } from "./rpt2.vue?vue&type=template&id=cbba0798&"
import script from "./rpt2.vue?vue&type=script&lang=js&"
export * from "./rpt2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports